var isCaptionTrack = function (_a) {
    var kind = _a.kind;
    return kind === 'subtitles' || kind === 'captions';
};
export var isShowingCaptionTrack = function (track) {
    return isCaptionTrack(track) && track.mode === 'showing';
};
/** The caption track in `language` (a BCP 47 tag, matched case-insensitively), or null if there isn't one. */
export var findCaptionTrack = function (tracks, language) {
    var _a;
    return (_a = tracks.find(function (track) { return isCaptionTrack(track) && track.language.toLowerCase() === language.toLowerCase(); })) !== null && _a !== void 0 ? _a : null;
};
